import { useEffect, useRef } from 'react';
import { PopupContainerMarker, CloseButton, Title, Controls, ButtonPrimary, ButtonSecondary } from './styles';

const MarkerPopup = (props) => {
  const { primaryAction, secondaryAction, onClose } = props;
  const popupRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  return (
    <PopupContainerMarker ref={popupRef}>
      <Title>What do you want to do?</Title>
      <Controls>
        <ButtonPrimary onClick={primaryAction}>Open Autodesk Viewer</ButtonPrimary>
        <ButtonSecondary onClick={secondaryAction}>Move to this point</ButtonSecondary>
      </Controls>
      <CloseButton onClick={onClose}>&times;</CloseButton>
    </PopupContainerMarker>
  );
};

export default MarkerPopup;
